import { render, staticRenderFns } from "./HousingIntakeNotes.vue?vue&type=template&id=c1a7d1c8&scoped=true&"
import script from "./HousingIntakeNotes.vue?vue&type=script&lang=js&"
export * from "./HousingIntakeNotes.vue?vue&type=script&lang=js&"
import style0 from "./HousingIntakeNotes.vue?vue&type=style&index=0&id=c1a7d1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a7d1c8",
  null
  
)

export default component.exports